import React from "react";

const ACCENT = "#161616";

const OldMinimalCalendar = ({
  state,
  calYear,
  calMonth,
  setCalMonth,
  setCalYear,
  packageDays,
  viewAvailableSlot,
}) => {
  const firstDay = new Date(calYear, calMonth, 1).getDay();
  const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
  const monthLabel = new Date(calYear, calMonth, 1).toLocaleString("en", {
    month: "long",
    year: "numeric",
  });
  const todayDate = new Date();

  const prevMonth = () =>
    setCalMonth((m) => {
      if (m === 0) {
        setCalYear((y) => y - 1);
        return 11;
      }
      return m - 1;
    });

  const nextMonth = () =>
    setCalMonth((m) => {
      if (m === 11) {
        setCalYear((y) => y + 1);
        return 0;
      }
      return m + 1;
    });

  const getCellDate = (d) =>
    `${calYear}/${String(calMonth + 1).padStart(2, "0")}/${String(d).padStart(2, "0")}`;

  const isAvailable = (d) => {
    if (state.appointmentValue === "Group Package") {
      const dow = new Date(calYear, calMonth, d)
        .toLocaleString("en", { weekday: "short" })
        .toUpperCase();
      return packageDays.includes(dow);
    }
    return (
      state.slots.find((s) => s.value === getCellDate(d))?.available === true
    );
  };

  const isSelected = (d) => getCellDate(d) === state.activeIndexData?.value;

  const isToday = (d) =>
    d === todayDate.getDate() &&
    calMonth === todayDate.getMonth() &&
    calYear === todayDate.getFullYear();

  const handleDay = (d) => {
    if (!isAvailable(d)) return;
    const idx = state.slots.findIndex((s) => s.value === getCellDate(d));
    if (idx === -1) return;
    viewAvailableSlot(idx, state.slots[idx], true);
  };

  return (
    <div
      style={{
        background: "white",
        borderRadius: "14px",
        border: "1px solid #e5e5e5",
        padding: "18px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "14px",
        }}
      >
        <button
          type="button"
          onClick={prevMonth}
          style={{
            background: "#f5f5f5",
            border: "none",
            cursor: "pointer",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            fontSize: "16px",
            color: ACCENT,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          ‹
        </button>
        <span style={{ fontSize: "14px", fontWeight: "700", color: "#161616" }}>
          {monthLabel}
        </span>
        <button
          type="button"
          onClick={nextMonth}
          style={{
            background: "#f5f5f5",
            border: "none",
            cursor: "pointer",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            fontSize: "16px",
            color: ACCENT,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          ›
        </button>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          marginBottom: "4px",
        }}
      >
        {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
          <div
            key={d}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "32px",
              fontSize: "11px",
              fontWeight: "700",
              color: ACCENT,
            }}
          >
            {d}
          </div>
        ))}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          rowGap: "2px",
        }}
      >
        {Array.from({ length: firstDay }).map((_, i) => (
          <div key={`e${i}`} style={{ height: "40px" }} />
        ))}

        {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((d) => {
          const avail = isAvailable(d);
          const sel = isSelected(d);
          const tod = isToday(d);
          return (
            <div
              key={d}
              onClick={() => handleDay(d)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "40px",
                cursor: avail ? "pointer" : "default",
              }}
            >
              <div
                style={{
                  width: "34px",
                  height: "34px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                  fontWeight: sel || tod ? "700" : "400",
                  background: sel ? ACCENT : "transparent",
                  color: sel ? "#fff" : !avail ? "#d8d8d8" : tod ? ACCENT : "#2d2d2d",
                  border: tod && !sel ? `1.5px solid ${ACCENT}` : "1.5px solid transparent",
                  transition: "all 0.15s",
                  userSelect: "none",
                  flexShrink: 0,
                }}
                onMouseEnter={(e) => {
                  if (avail && !sel) {
                    e.currentTarget.style.background = "#f5f5f5";
                    e.currentTarget.style.color = ACCENT;
                  }
                }}
                onMouseLeave={(e) => {
                  if (avail && !sel) {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = tod
                      ? ACCENT
                      : !avail
                      ? "#d8d8d8"
                      : "#2d2d2d";
                  }
                }}
              >
                {d}
              </div>
            </div>
          );
        })}
      </div>

      <div
        style={{
          display: "flex",
          gap: "14px",
          marginTop: "14px",
          paddingTop: "10px",
          borderTop: "1px dashed #e5e5e5",
        }}
      >
        {[
          { label: "Selected", bg: ACCENT, border: "none" },
          { label: "Today", bg: "transparent", border: `1.5px solid ${ACCENT}` },
          { label: "Unavailable", bg: "#efefef", border: "none" },
        ].map(({ label, bg, border }) => (
          <div
            key={label}
            style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#888" }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: bg,
                border: border || "none",
              }}
            />
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OldMinimalCalendar;